import {
  Button,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { useCollections } from '../hooks/useCollections';
import { useBottomSheet, BottomSheetSize } from '@shared/shell/bottomsheet/useBottomSheet';
import { ProductSelectBottomSheet } from '@features/products';
import CreateCollectionBottomSheet from './CreateCollectionBottomSheet';
import CollectionsTable from './CollectionsTable';
import { Icon } from '@shared/icons';

const Collections = () => {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet();
  const { collections: collectionsResponse, isLoading, isFetching } = useCollections();

  const collections =
    collectionsResponse?.status === 'success' ? collectionsResponse.data : [];

  const handleCreateCollection = () => {
    openBottomSheet({
      title: 'Select products',
      component: (
        <ProductSelectBottomSheet
          confirmButtonText={count =>
            `Continue with ${count} product${count !== 1 ? 's' : ''}`
          }
          onFinish={selections => {
            closeBottomSheet();
            openBottomSheet({
              title: 'Create collection',
              component: (
                <CreateCollectionBottomSheet
                  initialProducts={selections.map(s => s.product)}
                  onClose={closeBottomSheet}
                />
              ),
              size: BottomSheetSize.MD,
            });
          }}
          onClose={closeBottomSheet}
        />
      ),
      size: BottomSheetSize.MD,
    });
  };

  return (
    <Stack spacing={0}>
      <Stack
        direction="row"
        height={48}
        py={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          position: 'sticky',
          top: 0,
          backgroundColor: 'background.paper',
          zIndex: 99,
        }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {collections.length} collection{collections.length !== 1 ? 's' : ''}
        </Typography>
        <Button
          startIcon={<Icon icon="Plus01" />}
          variant="text"
          color="secondary"
          size="small"
          onClick={handleCreateCollection}
        >
          Create Collection
        </Button>
      </Stack>

      {isLoading || isFetching ? (
        <Stack direction="row" justifyContent="center" alignItems="center" p={4}>
          <CircularProgress />
        </Stack>
      ) : collections.length === 0 ? (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          p={6}
          spacing={2}
        >
          <Typography variant="body2" color="text.secondary">
            No collections yet. Create your first collection to organize products.
          </Typography>
          <Button
            startIcon={<Add />}
            variant="contained"
            size="small"
            onClick={handleCreateCollection}
          >
            Create Collection
          </Button>
        </Stack>
      ) : (
        <CollectionsTable collections={collections} />
      )}
    </Stack>
  );
};

export default Collections;
